import { FormattedMessage } from 'react-intl'
import { Dashboard, MenuBook, PlayCircleFilled, VerifiedUser } from '@material-ui/icons'
import React from 'react'
import StudentDashboard from '../Views/StudentPrivate/StudentDashboard'
import StudentMainMenu from '../Views/StudentPrivate/StudentMainMenu'
import StudentLesson from '../Views/StudentPrivate/StudentLesson'
import StudentAcceptTerms from '../Views/StudentPrivate/StudentAcceptTerms'

const studentPrivateRoutes = [
    {
        path: '/student/unity',
        name: <FormattedMessage id="globalwords.dashboard" defaultMessage="Student Page" />,
        id: 'Dashboard',
        icon: Dashboard,
        component: StudentDashboard,
        acceptRoles: ['STUDENT'],
    },
    {
        path: '/student',
        name: <FormattedMessage id="student.mainmenu" defaultMessage="My Courses" />,
        id: 'MainMenu',
        icon: MenuBook,
        component: StudentMainMenu,
        acceptRoles: ['STUDENT'],
    },
    {
        path: '/student/accept-terms',
        name: <FormattedMessage id="student.accept.terms" defaultMessage="Privacy terms and conditions" />,
        id: 'AcceptTerms',
        icon: VerifiedUser,
        component: StudentAcceptTerms,
        acceptRoles: ['STUDENT'],
    },
    {
        path: '/student/lesson/:customLessonId',
        name: <FormattedMessage id="student.lesson" defaultMessage="Lesson" />,
        id: 'Lesson',
        icon: PlayCircleFilled,
        component: StudentLesson,
        acceptRoles: ['STUDENT'],
    },
]

export default studentPrivateRoutes
